import { ASUNTOS_DE_CONTACTO } from '@/features/solicitudes/types/solicitudes.types';

/*
  Vault 346 (L0, D8, D24): el contacto público es el formulario, que llega a Plataforma › Solicitudes.
  Se sacaron los correos de un dominio que no es de Prixia, la dirección y el chat en vivo inventados y
  las redes que apuntaban a «#». El correo y el WhatsApp reales salen de la configuración de la
  plataforma (`useContactoPublico`) y no se muestran mientras estén vacíos.
*/

// ── Asunto options (para SearchableSelect) ──

export const subjectOptions = ASUNTOS_DE_CONTACTO.map((a) => ({ value: a.valor, label: a.rotulo }));

// ── FAQ items ──

export interface FaqItem {
  question: string;
  answer: string;
}

export const contactFaqItems: FaqItem[] = [
  {
    question: '¿Cómo pruebo Prixia?',
    answer:
      'Pide tu Mini Prixia con este formulario. Te escribimos con un enlace personal y, desde que entras, tienes 15 días para recorrerla, guiada por misiones.',
  },
  {
    question: '¿Mis datos los ve otra empresa?',
    answer: 'No. Cada empresa ve sólo lo suyo: sus productos, sus precios y sus decisiones.',
  },
  {
    question: '¿Qué hacen con los datos de este formulario?',
    answer:
      'Los usamos para contactarte sobre Prixia. Si quieres que los borremos, escríbenos por aquí y lo hacemos.',
  },
];
